import React from 'react'
import { getThemeStyle } from '../../utilities/helpers'
import { formPagePath } from '../../utilities/route'
import DriverStatBar from './driver-stat-bar'
import Button from './button'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { LAPTOP, TABLET } from '../../utilities/breakpoints'
import CompactStatRow from './compact-stat-row'
import { sortingService } from '../../utilities/sortingService'

const mapStateToProps = ({ survey: { sortingType, sortAscending } }) => {
  return {
    sortingType,
    sortAscending
  };
};

const ThemeStatCardNew = ({
  theme,
  surveyId,
  languageCode,
  useTranslate,
  sortingType,
  sortAscending
}) => {

  const isGroupResultTotalNull = () => {
    const sum = theme.drivers.reduce(function(sum, current) {
      if (current.result === null) {
        return sum;
      } else {
        return sum + current.result;
      }
    }, null);
    return (sum === null)
  }

  const groupResult = !isGroupResultTotalNull() ? theme.result : null;
  const to = formPagePath(languageCode, surveyId, 'finish', theme.id, 'details');

  const sortingFunction = sortingService.getSortingFunction(sortingType);
  const sortedDrivers = [...theme.drivers];
  sortedDrivers.sort(sortingFunction(sortAscending ? sortAscending : false));

  return (
    <ThemeCard>
      <Header style={{ backgroundColor: getThemeStyle(theme.surveyThemeIndex).bgColor }}>
        <h4>{theme.title}</h4>
        <Button
          as={Link}
          to={to}
          className={"more-details-btn"}
          size={"sm"}
          kind={"gray"}
          addArrow={true}
        >
          {useTranslate("data_vault.more_details")}
        </Button>
      </Header>
      <ResultContainer>
        {/*<TableColumnLabel style={{marginBottom: "8px"}}>{useTranslate("data_vault.current_state")}</TableColumnLabel>*/}
        <DriverStatBar
          result={groupResult}
          useTranslate={useTranslate}
          barColor={getThemeStyle(theme.surveyThemeIndex).bgColor}
        />
      </ResultContainer>
      <DriversContainer>
        {sortedDrivers.map((driver, index) => {
          return (
            <CompactStatRow
              key={index}
              index={index}
              type={"driver"}
              result={driver.result}
              rate={driver.rate}
              title={driver.title}
              useTranslate={useTranslate}
              showLabels={index === 0}
              showTitleLabel={true}
              showNumbers={false}
            />
          )
        })}
      </DriversContainer>
    </ThemeCard>
  )
}

export default connect(mapStateToProps)(ThemeStatCardNew);

const ThemeCard = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.06);

  & + & {
    margin-top: 1rem;
  }
`;

const Header = styled.div`
  border-radius: 10px 10px 0 0;
  padding: 20px 15px;
  color: #fff;

  gap: 20px;

  .engager-btn {
    width: auto;
    margin-top: 20px;
  }

  h4 {
    margin: 0;
  }

  @media${TABLET} {
    padding: 30px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;

    .engager-btn {
      margin-top: 0;
    }
  }

  @media${LAPTOP} {
    padding: 40px 40px;
  }
`;

const ResultContainer = styled.div`
  padding: 20px 15px;
  
  @media${TABLET} {
    padding: 30px 20px;
  }
  
  @media${LAPTOP} {
    padding: 35px 40px;
  }
`;

const DriversContainer = styled.div`
  border-top: 1px solid #d9d9d9;
  padding: 20px 15px;
  
  @media${TABLET} {
    padding: 20px 20px;
  }
  
  @media${LAPTOP} {
    padding: 20px 40px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/theme-stat-card.js